export default __webpack_public_path__ + "static/media/ReviewsUploadIcon.f8ef874e.svg";